/* path: src/components/Fields/DateSelector.jsx */
import React, { useState, useEffect } from 'react';
import Calendar from './Calendar';
import './css/calendar.css';
import './css/mobile.css';
import moment from 'moment-timezone';
import useSuggestedDates from './Hooks/useSuggestedDates';

moment.locale('nl');


const DateSelector = ({
  guests,
  formData,
  handleChange,
  resetFormDataFields,
  timeblocks, // Note: This prop seems unused in the provided snippet, might be used elsewhere
  expanded,
  setCurrentExpandedField,
  restaurantData,
  reservations,
  onMonthChange,
  giftcard, // prop for giftcard selection
}) => {
  const [isExpanded, setIsExpanded] = useState(expanded || false);

  // Track the currently displayed month
  const [displayedMonth, setDisplayedMonth] = useState(moment().tz('Europe/Amsterdam').startOf('month'));

  const handleDateSelect = (date) => {
    window.selectedDate = formatDateForFilter(date);
    handleChange({
      target: { name: 'date', value: date },
    });
    resetFormDataFields(['time']);

    // Collapse the calendar and suggestions once a date is selected
    setIsExpanded(false);

    if (setCurrentExpandedField) {
      setCurrentExpandedField('time');
    }
  };

  const formatDateForFilter = (date) => {
    if (!date) return '';
    const year = date.getFullYear();
    const month = (`0${date.getMonth() + 1}`).slice(-2);
    const day = (`0${date.getDate()}`).slice(-2);
    return `${year}-${month}-${day}`;
  };

  // Wrap onMonthChange to update displayedMonth
  const handleCalendarMonthChange = (newMonthDate) => {
    setDisplayedMonth(newMonthDate);
    onMonthChange && onMonthChange(newMonthDate);
  };

  const suggestedDates = useSuggestedDates({
    restaurantData,
    reservations,
    displayedMonth,
    guests,
    giftcard,
  });

  const handleSuggestionClick = (date) => {
    // Pass the Date object directly to handleDateSelect
    handleDateSelect(date);
  };

  const formatSuggestionTitle = (dateMoment) => {
    const weekday = dateMoment.format('dddd'); // e.g. "woensdag"
    const capitalizedWeekday = weekday.charAt(0).toUpperCase() + weekday.slice(1);

    const day = dateMoment.format('D'); // e.g. 7
    const monthName = dateMoment.format('MMMM'); // januari
    const capitalizedMonthName = monthName.charAt(0).toUpperCase() + monthName.slice(1);

    return `${capitalizedWeekday} ${day} ${capitalizedMonthName}`;
  };

  const formatSuggestionSubtitle = (dateMoment) => {
    // Keep consistent formatting e.g., DD-MM-YYYY
    return `${dateMoment.format('DD-MM-YYYY')} beschikbaar`; 
  };

  return (
    <div className="form-group date-selector-container">
      <label htmlFor="date" className="default-text-color">
        Datum
      </label>
      <div className={`calendar-content-container ${isExpanded ? 'calendar-expanded' : 'calendar-collapsed'}`}>
        <Calendar
          selectedDate={formData.date ? formData.date : null}
          onSelectDate={handleDateSelect}
          isExpanded={isExpanded}
          setIsExpanded={setIsExpanded}
          restaurantData={restaurantData}
          guests={guests}
          reservations={reservations}
          onMonthChange={handleCalendarMonthChange}
          giftcard={giftcard} // pass giftcard prop to Calendar
        />
        
        {isExpanded && (
          <div className="boxes-container">
            <h3>Enkele Suggesties</h3>
            {suggestedDates.length > 0 ? (
              suggestedDates.map((dateMoment, index) => (
                <div
                  key={index}
                  className="suggestion-box"
                  // Pass the Date object from the moment object
                  onClick={() => handleSuggestionClick(dateMoment.toDate())} 
                >
                  <span style={{fontWeight:"500"}}>{formatSuggestionTitle(dateMoment)}</span>
                  <div>{formatSuggestionSubtitle(dateMoment)}</div>
                </div>
              ))
            ) : (
              <div className="no-suggestion-box">
                <span>Geen beschikbare data gevonden in {displayedMonth.format('MMMM YYYY')}.</span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default DateSelector;